import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { message } from "antd";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";

import { CiCircleChevLeft } from "react-icons/ci";

import { AuthAction } from "../../store/actions";

import LoginLayout from "../../components/layouts/login-layout";
import { Buttons, Spacer, inputFields, loginAndSignup } from "../../components";

import { Images, Utils } from "../../config";

const PasswordForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const prevData = location.state;

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const passwordRequirements = [
    { label: "At least 8 characters", test: (pwd) => pwd.length >= 8 },
    { label: "At least one letter", test: (pwd) => /[A-Za-z]/.test(pwd) },
    { label: "At least one number", test: (pwd) => /\d/.test(pwd) },
  ];

  const handleContinue = () => {
    if (!password) {
      message.error("Password cannot be empty.");
    } else if (!Utils.passwordRegex.test(password)) {
      message.error(
        "Your password must have at least 8 characters, one letter, and one number."
      );
    } else if (!confirmPassword) {
      message.error("Confirm password cannot be empty.");
    } else if (password !== confirmPassword) {
      message.error("Passwords do not match.");
    } else {
      const body = {
        ...prevData,
        password,
      };

      dispatch(
        AuthAction.studentSignup(body, (res) => {
          if (res.status === 200) {
            navigate("/login", {
              state: prevData,
            });
          }
        })
      );
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleContinue();
    }
  };

  return (
    <LoginLayout imgSignup>
      <div className="flex flex-col items-center justify-center px-[6.25em] py-[5em] bg-login-gradient gap-4">
        <div className="relative">
          <CiCircleChevLeft
            className="text-[2.5em] absolute -left-[4.175em] top-1 cursor-pointer"
            onClick={() => {
              window.history.back();
            }}
          />
          <img src={Images.UnivisionLogoWithText} className="h-[3.75em]" />
        </div>
        <div className="flex flex-col gap-2 items-center w-full text-center">
          <div className="text-main font-bold text-[2.5em]">
            Set New Password
          </div>
          <div className="text-[1.375em] font-semibold">
            Enter New Password And Confirm Password
          </div>
        </div>
        <Spacer height={5} />
        <div className="flex flex-col gap-2 w-[31.25em]">
          <div>
            <loginAndSignup.LoginInputTitle title="Set Password" />
            <Spacer height={10} />
            <inputFields.DefaultInput
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              onKeyDown={handleKeyDown}
              placeholder="Enter your password"
              type="password"
            />
          </div>
          <Spacer height={10} />
          <div>
            <loginAndSignup.LoginInputTitle title="Confirm New Password" />
            <Spacer height={10} />
            <inputFields.DefaultInput
              onChange={(e) => setConfirmPassword(e.target.value)}
              value={confirmPassword}
              onKeyDown={handleKeyDown}
              placeholder="Enter your password"
              type="password"
            />
          </div>
          <Spacer height={20} />
          <div className="text-[1.125em]">
            The password must meet the following requirements:
          </div>

          <div className="flex flex-col gap-2 mb-4">
            {passwordRequirements.map((req, index) => (
              <div key={index} className="flex items-center gap-2">
                {req.test(password) ? (
                  <FaCheckCircle className="text-green-500" />
                ) : (
                  <FaTimesCircle className="text-red-500" />
                )}
                <div>{req.label}</div>
              </div>
            ))}
          </div>
          <Buttons.DefaultButton onClick={handleContinue} width="full">
            Continue
          </Buttons.DefaultButton>
        </div>
      </div>
    </LoginLayout>
  );
};

export default PasswordForm;
